import { AgnesBadge, AgnesBadgeProps, cn } from '@agnes/ui';
import { cva, VariantProps } from 'class-variance-authority';
import { Workflow } from 'lucide-react';

export interface BadgeEmAnaliseProps
  extends VariantProps<typeof badgeCVA>, Omit<AgnesBadgeProps, 'children'> {}

const badgeCVA = cva(
  'whitespace-nowrap text-agnes-primary bg-agnes-primary/10 dark:bg-agnes-primary/30 dark:text-agnes-primary-light',
);

const iconCVA = cva('flex items-center justify-start gap-1 justify-self-start', {
  variants: {
    size: {
      sm: 'w-3 h-3',
      md: 'w-4 h-4',
      lg: 'w-6 h-6',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export function BadgeEmAnalise({ className, size, ...props }: BadgeEmAnaliseProps) {
  return (
    <AgnesBadge className={cn(badgeCVA(), className)} size={size} {...props}>
      <Workflow className={cn(iconCVA({ size }))} />
      Em análise
    </AgnesBadge>
  );
}
